import { render, staticRenderFns } from "./HollyFiSideBarNavLink.vue?vue&type=template&id=552dec40&"
import script from "./HollyFiSideBarNavLink.vue?vue&type=script&lang=js&"
export * from "./HollyFiSideBarNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports